<template>
  <div class="fail-dialog">
    <p>文件名: {{fileName}}</p>
    <div class="page-table">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#fafafa' }"
        height="300"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="entName"
          label="企业名称"
          show-overflow-tooltip
          align="left"
        >
        </el-table-column>
        <el-table-column
          prop="reason"
          label="失败原因"
          show-overflow-tooltip
          align="left"
        >
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="totalRecord"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getImportFailList
} from '@api/corporateInteraction/enterprise'
export default {
  props: {
    failItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fileName: '',
      pageNum: 1,
      pageSize: 10,
      totalRecord: 0,
      historyId: null,
      tableData: []
    }
  },
  watch: {
    failItem: {
      handler(val) {
        this.fileName = val.fileName || ''
        this.historyId = val.id || null
        this.getfailList()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 获取失败列表
    getfailList() {
      let params = {
        historyId: this.historyId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getImportFailList(params).then(res => {
        const { data, code } = res.data
        if (code === '0000') {
          this.tableData = data.results || []
          this.totalRecord = data.totalRecord || 0
        }
      })
    },
    //  表格翻页
    handleCurrentChange(pageNum, e) {
      this.pageNum = pageNum
      this.getfailList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getfailList()
    }
  }
}
</script>

<style lang="scss" scoped>
.fail-dialog{
  .page-table{
    overflow: hidden;
    .table-page{
      margin-top: 20px;
      /deep/.el-pagination{
        float: right;
      }
    }
  }
}
</style>
